import { render, staticRenderFns } from "./GatewayItem.vue?vue&type=template&id=6fd2b8bc&"
import script from "./GatewayItem.vue?vue&type=script&lang=js&"
export * from "./GatewayItem.vue?vue&type=script&lang=js&"
import style0 from "./GatewayItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports